module.exports = __webpack_public_path__ + "static/img/la.c7a77b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/la.jpg
// module id = Yb5C
// module chunks = 1